/**
 * GEMMOLOG FORM
 * ---------------------------------------------------------------------------------------------
 * Obsluga formularza zapytania do gemmologa (sections/gemmolog-form.liquid).
 *
 * Zakres (spec Adtrip v2.0, rozdzialy 6.4 i 6.5):
 *   - pulapka na boty (honeypot) - blokuje wysylke, gdy ukryte pole zostalo wypelnione,
 *   - odstep miedzy zgloszeniami z tej samej przegladarki (localStorage),
 *   - komunikat bledu przy braku zgody - pod polem, nie jako alert na gorze,
 *   - prefiks tematu zgloszenia doklejany do ukrytego pola,
 *   - zdarzenia GA4 i Meta po POPRAWNEJ wysylce.
 *
 * UWAGA: Shopify przeladowuje strone po wyslaniu formularza kontaktowego, dlatego dane do
 * pomiaru zapisujemy w sessionStorage PRZED wysylka i odczytujemy po powrocie z contact_posted=true.
 */
(function () {
  'use strict';

  var STORAGE_THROTTLE = 'syncret:gemmolog:last-submit';
  var STORAGE_PENDING = 'syncret:gemmolog:pending-lead';

  function readConfig(root) {
    var node = root.querySelector('[data-gemmolog-config]');
    if (!node) return null;
    try {
      return JSON.parse(node.textContent);
    } catch (error) {
      return null;
    }
  }

  function safeGet(storage, key) {
    try {
      return window[storage].getItem(key);
    } catch (error) {
      return null;
    }
  }

  function safeSet(storage, key, value) {
    try {
      window[storage].setItem(key, value);
    } catch (error) {
      /* Tryb prywatny albo zablokowane dane witryny - pomiar i blokada po prostu nie dzialaja. */
    }
  }

  function safeRemove(storage, key) {
    try {
      window[storage].removeItem(key);
    } catch (error) {
      /* jw. */
    }
  }

  function throttled(minutes) {
    if (!minutes) return false;
    var last = parseInt(safeGet('localStorage', STORAGE_THROTTLE), 10);
    if (!last) return false;
    return Date.now() - last < minutes * 60 * 1000;
  }

  /* Zdarzenia po powrocie ze strony potwierdzenia. Wywolujemy tylko wtedy, gdy Shopify
     faktycznie przyjal zgloszenie - inaczej liczylibysmy nieudane proby. */
  function trackLead(config) {
    if (!config.analytics) return;

    var raw = safeGet('sessionStorage', STORAGE_PENDING);
    safeRemove('sessionStorage', STORAGE_PENDING);

    var lead = {};
    if (raw) {
      try {
        lead = JSON.parse(raw);
      } catch (error) {
        lead = {};
      }
    }

    if (typeof window.gtag === 'function') {
      window.gtag('event', 'generate_lead', {
        item_id: lead.sku || '',
        item_name: lead.product || '',
        method: 'gemmolog_form'
      });
    }

    if (typeof window.fbq === 'function') {
      window.fbq('track', 'Lead', {
        content_ids: lead.sku ? [lead.sku] : [],
        content_name: lead.product || ''
      });
    }
  }

  function init(section) {
    if (section.dataset.gemmologInit) return;
    section.dataset.gemmologInit = 'true';

    var config = readConfig(section) || {};

    if (config.posted) {
      trackLead(config);
      return;
    }

    var form = section.querySelector('form');
    if (!form) return;

    var trap = form.querySelector('[data-gemmolog-trap]');
    var consent = form.querySelector('[data-gemmolog-consent]');
    var consentWrapper = form.querySelector('[data-gemmolog-consent-wrapper]');
    var productField = form.querySelector('[name="contact[Produkt]"]');
    var skuField = form.querySelector('[name="contact[SKU]"]');

    /* Ukryte pole z prefiksem tematu. Tworzymy je z JS, bo wartosc zalezy od wybranego
       egzemplarza, a ten moze sie zmienic juz po zaladowaniu strony. */
    var subjectField = null;
    if (config.subjectPrefix) {
      subjectField = document.createElement('input');
      subjectField.type = 'hidden';
      subjectField.name = 'contact[Zgłoszenie]';
      form.appendChild(subjectField);
    }

    if (consent && consentWrapper) {
      consent.addEventListener('change', function () {
        if (consent.checked) consentWrapper.removeAttribute('data-field-invalid');
      });
    }

    form.addEventListener('submit', function (event) {
      /* 1. Bot wypelnil pole, ktorego czlowiek nie widzi. Cicho przerywamy. */
      if (config.honeypot && trap && trap.value.trim() !== '') {
        event.preventDefault();
        return;
      }

      /* 2. Zgoda obowiazkowa - komunikat pod polem zamiast natywnego dymka przegladarki. */
      if (consent && !consent.checked) {
        event.preventDefault();
        if (consentWrapper) {
          consentWrapper.setAttribute('data-field-invalid', 'true');
          consentWrapper.scrollIntoView({ block: 'center', behavior: 'smooth' });
        }
        consent.focus();
        return;
      }

      /* 3. Odstep miedzy zgloszeniami z tej samej przegladarki. */
      if (throttled(config.throttleMinutes)) {
        event.preventDefault();
        if (config.throttleMessage) window.alert(config.throttleMessage);
        return;
      }

      var productName = productField ? productField.value.trim() : '';
      var sku = skuField ? skuField.value.trim() : '';

      if (subjectField) {
        subjectField.value = productName
          ? config.subjectPrefix + ' ' + productName
          : config.subjectPrefix;
      }

      safeSet('localStorage', STORAGE_THROTTLE, String(Date.now()));
      safeSet('sessionStorage', STORAGE_PENDING, JSON.stringify({ product: productName, sku: sku }));
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('.shopify-section--gemmolog-form').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target.querySelectorAll ? event.target : document);
  });
})();
